import { gql } from "@apollo/client";

export default gql`
  mutation deleteAnnouncementCategory($input: DeleteChangelogCategoryInput!){
    deleteAnnouncementCategory(input: $input){
        success
        data{
            _id
            color
            translations
            createdAt
            updatedAt
        }
        error
        message
    }
}
`
